module.exports = __webpack_public_path__ + "img/apartment.2a5b657c.svg";